import { Skeleton } from "antd";

const Loading = ({ mode }) => {
  return (
    <div
      className={`flex bg-white items-center ${
        mode === "horizontal"
          ? "justify-between pt-3 pb-4 px-4 rounded-t-2xl shadow-footer h-[81px]"
          : "flex-col space-y-4 p-2 "
      }`}
    >
      <Skeleton.Button active block={mode === "vertical"}></Skeleton.Button>
      <Skeleton.Button active block={mode === "vertical"}></Skeleton.Button>
      <Skeleton.Button active block={mode === "vertical"}></Skeleton.Button>
      <Skeleton.Button active block={mode === "vertical"}></Skeleton.Button>
    </div>
  );
};
export default Loading;
